import { render, staticRenderFns } from "./MStoreNotification.vue?vue&type=template&id=1cb2b573&"
import script from "./MStoreNotification.vue?vue&type=script&lang=ts&"
export * from "./MStoreNotification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports